import { useCallback } from "react";

import useClient from "hooks/atPort/useClient";

export const useCreateSystemNotification = () => {
  const client = useClient();

  const create = useCallback(
    async (data: CreateAtPortSystemNotification) => {
      return await client.client({
        method: "POST",
        url: "/system-notification",
        data,
      });
    },
    [client]
  );

  return { create };
};
